import { useEffect } from 'react';
import { cn } from '@/lib/utils';
import { useCognitoAuth } from '@/hooks/useCognitoAuth';
import { PageLoader } from '@/components/page-loader';

export function LoginForm({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) {
  const { signInWithRedirect, isAuthenticated, isLoading } = useCognitoAuth();

  useEffect(() => {
    // Only redirect to Cognito hosted UI if user is not authenticated and auth check is complete
    if (!isLoading && !isAuthenticated) {
      signInWithRedirect().catch((err) => {
        // Handle UserAlreadyAuthenticatedException gracefully
        // This can happen in race conditions where auth state changes between check and redirect
        if (err?.name === 'UserAlreadyAuthenticatedException') {
          // User is already authenticated, the auth hook will handle the state update
          console.log('User already authenticated, skipping redirect');
        } else {
          // Re-throw other errors
          throw err;
        }
      });
    }
  }, [signInWithRedirect, isAuthenticated, isLoading]);

  return (
    <div className={cn('flex flex-col gap-6', className)} {...props}>
      <div className="flex items-center justify-center min-h-[400px]">
        <PageLoader />
      </div>
    </div>
  );
}
